import { City, Country, ListRoomResponse, LoginResponse, StaffNotification, StaffNotificationTopics, State, TENANT_MODEL } from '@fitness-force/models';
import { StaffService } from '@fitness-force/api';
import { TenantService } from '@fitness-force/api';
import { Store } from '@ngrx/store';
import { environment } from './../../environments/environment';
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
  AUTO_LOGIN,
  ActionTypes,
  ERROR_COMPANY_DETAILS, ERROR_TENANT_LIST, FETCHED_COMPANY_DETAILS, FETCHED_CURRENT_LOCATION, FETCHED_TENANT_BY_ID_SUCCESS, FETCHED_TENANT_LIST_SUCCESS, FETCH_APPOINTMENT_TYPE_LIST, FETCH_CITY_MASTER, FETCH_CITY_MASTER_LIST_SUCCESS, FETCH_CLASS_TYPE_LIST, FETCH_COUNTRY_MASTER, FETCH_COUNTRY_MASTER_LIST, FETCH_ROOM_LIST, FETCH_SERVICETYPE_LIST_SUCCESS, FETCH_STAFF_LIST, FETCH_STAFF_LIST_ALL, FETCH_STAFF_NOTIFICATIONS, FETCH_STAGE_MASTER_SUCCESS, FETCH_TRIAL_MASTER_LIST, LOGIN, LOGIN_FAILED, LOGIN_SUCCESS, LOGIN_WITH_GOOGLE, SELECT_LANGUAGE, SET_ACCESSED_TENANT, SET_ACCESSED_TENANT_SUCCESS, SET_ACTIVE_TENANT, SET_CLAIMS_DETAILS, SET_USER_THEME, STAFF_NOTIFICARIONS_SUCCESS, STATSIG_UPDATE_USER, STATSIG_UPDATE_USER_SUCCESS,
} from './actions';
import { catchError, map, of, switchMap, Observable, tap, mergeMap, withLatestFrom, skipWhile, combineLatest, debounceTime } from 'rxjs';
import { Injectable } from '@angular/core';
import { CLAIMS_INFO, TENANTS_INFO, COMPANY_INFO, AUTH_STATE, LOCATION_STATE, STAFF_STATE } from './app.state';
import { AppInitService, AppointmentTypesService, AuthSevices, CityService, ClassTypeService, CountryService, FeaturebaseService, LocationService, OpportunityStageService, RoomService, ServiceTypeService, StateService, TrialService } from '@fitness-force/api';
import { OpportunityBoardType } from '@fitness-force/enum';
import { FETCH_STATE_MASTER, FETCH_STATE_MASTER_LIST_SUCCESS } from './actions/state.action';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { CONSTANTS_DATA} from '@fitness-force/constants';
import Statsig, { StatsigUser } from 'statsig-js';
import { Location } from '@angular/common';
import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { SET_ACTIVE_TENANT_DATA } from './actions/tenant.actions';


@Injectable()
export class CompanyEffects {
  accessTenants: Array<TENANT_MODEL> = []
  selectedTenant: any;
  tenantId: any;
  tenant: any;
  selected_tenant: any;
  currentRoute: any
  country: any;
  state: any;
  city: any;
  user:any

  staffListParams = new Map();
  staffListAllParams = new Map();
  constructor(
    private actions$: Actions,
    private store: Store,
    private appInit: AppInitService,
    private tenantservice: TenantService,
    private staff: StaffService,
    private stageMasterService: OpportunityStageService,
    private countryService: CountryService,
    private appointmentTypeService: AppointmentTypesService,
    private classTypeService: ClassTypeService,
    private stateService: StateService,
    private cityService: CityService,
    private serviceTypeService: ServiceTypeService,
    private roomService: RoomService,
    private locationService: LocationService,
    private authService: AuthSevices,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private location: Location,
    private featurebaseService:FeaturebaseService,
    private trialService:TrialService
    ) 
    {
    this.staffListParams.set('PageNumber', { name: 'PageNumber', value: 1 });
    this.staffListParams.set('PageSize', { name: 'PageSize', value: 9999 });
    this.staffListParams.set('page_number', { name: 'page_number', value: 1 });
    this.staffListParams.set('page_size', { name: 'page_size', value: 9999 });
  }

  getCompanyDetails$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('FETCHED_COMPANY_DETAILS'),
      withLatestFrom(this.store.select(COMPANY_INFO)),
      switchMap(([action, companyInfo]: any) => {
        return (localStorage.getItem('token') && companyInfo.compDetails?.uuid) ? of(companyInfo.compDetails) 
          : this.appInit.getCompanyInformation();
      }),
      mergeMap((companyDetails: any) => [
        SELECT_LANGUAGE({ lang: localStorage.getItem('DEFAULT_LANGUAGE') ? JSON.parse(localStorage.getItem('DEFAULT_LANGUAGE') || '{}') : this.appInit.parseLanguage(companyDetails.primary_language) }),
        FETCHED_COMPANY_DETAILS({ companyDetails: companyDetails }),
        //FETCH_CURRENT_LOCATION()
      ]),
      catchError((err) => of(
        ERROR_COMPANY_DETAILS({ err: { details: { status: err.originalError.status }, status: true } }))),
       // this.router.navigateByUrl('/admin/')
    );
  });



  getTenantList$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('FETCHED_TENANT_LIST'),
      switchMap(() => this.tenantservice.GetTenantList().pipe(
        map((tenantList: any) => {
          return FETCHED_TENANT_LIST_SUCCESS({ all_tenant: tenantList.items })
        }),
        catchError((err) => of(console.log(err))),
      ))
    )
  });



  getTenantListSuccess$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('FETCHED_TENANT_LIST_SUCCESS'),
      map((tenantList: any) => SET_ACCESSED_TENANT({ all_tenant: tenantList.all_tenant })),
      catchError((err) => of(console.log(err)))
    )
  });


  setAccessTenant$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('SET_ACCESSED_TENANT'),
      withLatestFrom(this.store.select(CLAIMS_INFO)),
      skipWhile(([tenantList, data]: any) => !tenantList || tenantList.length == 0 || data == undefined || !data?.accessed_tenant),
      map(([tenantList, data,]: any) => {
        const aTenants = tenantList.all_tenant.filter((item: any) => { return data.accessed_tenant.includes((item.id).toString()) })
        return SET_ACCESSED_TENANT_SUCCESS({ accessed_tenant: aTenants })
      }),
      catchError((err) => {
        return of(ERROR_TENANT_LIST({ err }));
      }),
    )
  });


  setAccessTenantSuccess$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('SET_ACCESSED_TENANT_SUCCESS'),
      map((action: any) => {
        const TENANT_DEFAULT = localStorage.getItem('TENANT_DEFAULT');
        const queryTenantId = this.activeRoute.snapshot.queryParams['tenant'];
        let selectedTenant;
  
        // Determine the tenant ID to be used for finding the selected tenant
        const tenantIdToFind = queryTenantId && TENANT_DEFAULT == queryTenantId ? queryTenantId : TENANT_DEFAULT;
        
        // Attempt to find the selected tenant based on the determined tenant ID
        selectedTenant = action.accessed_tenant.find((t: { id: number; }) => t.id == parseInt(tenantIdToFind));
  
        // If no specific tenant ID to find, or not found, default to the first active or any tenant
        if (!selectedTenant) {
          selectedTenant = action.accessed_tenant.find((t: { status: string; }) => t.status.toLowerCase() == 'active') || action.accessed_tenant[0];
        }
  
        // Update localStorage and navigate if necessary based on the tenant's status
        if (selectedTenant && (selectedTenant.status.toLowerCase() == 'active' || selectedTenant.status.toLowerCase() == 'presales')) {
          localStorage.setItem('TENANT_DEFAULT', selectedTenant.id.toString());
        } else {
          // Navigate to 'tenant-not-found' but still dispatch SET_ACTIVE_TENANT
          this.router.navigateByUrl('tenant-not-found');
        }
        this.tenantservice.updateTenantPresaleStatus(selectedTenant);
        // Dispatch SET_ACTIVE_TENANT in all cases
        return SET_ACTIVE_TENANT({ selected_tenant: selectedTenant });
      }),
      catchError((err) => {
        return of(ERROR_TENANT_LIST({ err }));
      }),
    )
  });


  setActiveTenant$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('SET_ACTIVE_TENANT'),
      skipWhile((action: any) => !action.selected_tenant),
      switchMap((action: any) => {
        const tenant = action.selected_tenant;
        return combineLatest({
          countries: this.countryService.GetCountry(environment.BASE_URL).pipe(
            catchError((err) => {
              console.error('Error fetching countries:', err);
              return of([]);
            })
          ),
          stages: this.stageMasterService.OpportunityStageMasterListService(tenant.id, OpportunityBoardType.NewMemberBoard).pipe(
            catchError((err) => {
              console.error('Error fetching stages:', err);
              return of({ items: [] });
            })
          ),
          serviceTypes: this.serviceTypeService.GetServiceType(tenant.id).pipe(
            catchError((err) => {
              console.error('Error fetching service types:', err);
              return of({ items: [] });
            })
          ),
          classTypes: this.classTypeService.getClassTypes(tenant.id).pipe(
            catchError((err) => {
              console.error('Error fetching class types:', err);
              return of({ items: [] });
            })
          ),
          appointmentTypes: this.appointmentTypeService.getAppointmentTypes(tenant.id, []).pipe(
            catchError((err) => {
              console.error('Error fetching appointment types:', err);
              return of({ items: [] });
            })
          ),
          states: this.stateService.GetState(environment.BASE_URL, tenant.country).pipe(
            catchError((err) => {
              console.error('Error fetching states:', err);
              return of([]);
            })
          ),
          cities: this.cityService.GetCity(environment.BASE_URL, tenant.country, tenant.state).pipe(
            catchError((err) => {
              console.error('Error fetching cities:', err);
              return of([]);
            })
          ),
          staffList: this.staff.GetStaffList(environment.BASE_URL, tenant.id, this.getAllParams).pipe(
            catchError((err) => {
              console.error('Error fetching staff list:', err);
              return of({ items: [] });
            })
          ),
          tenantDetails: this.tenantservice.GetTenantById(environment.BASE_URL, tenant.id).pipe(
            catchError((err) => {
              console.error('Error fetching tenant details:', err);
              return of(null);
            })
          ),
          staffNotifications: this.staff.StaffNotification().pipe(
            catchError((err) => {
              console.error('Error fetching staff notifications:', err);
              return of(null);
            })
          ),
          trials: this.trialService.getTrials(tenant.id).pipe(
            catchError((err) => {
              console.error('Error fetching trials:', err);
              return of({ items: [] });
            })
          ),
          queryParams: this.activeRoute.queryParams
        }).pipe(
          tap(({ tenantDetails }) => {
            if (tenantDetails?.id && tenantDetails?.tenant != tenant.id) {
              this.updateQueryParams(tenant.id);
            } else if (!tenantDetails?.id) {
              this.updateQueryParams(tenant.id);
            }
            localStorage.setItem('TENANT_DEFAULT', tenant.id);
          }),
          map((data) => {
            const country = data.countries?.length > 0 ? this.findCountry(data.countries, tenant.country) : null;
            const state = data.states?.length > 0 ? (this.findState(data.states, tenant.state) || data.states[0]) : null;
            const city = data.cities?.length > 0 ? (this.findCity(data.cities, tenant.city) || data.cities[0]) : null;

            const actions: any[] = [
              STATSIG_UPDATE_USER({ selected_tenant: tenant }),
              SET_USER_THEME()
            ];

            // Only dispatch actions for successful API calls
            if (data.countries?.length > 0) {
              actions.push(FETCH_COUNTRY_MASTER_LIST({ countries: data.countries }));
              if (country) {
                actions.push(FETCH_COUNTRY_MASTER({ country }));
              }
            }

            if (data.stages?.items?.length > 0) {
              actions.push(FETCH_STAGE_MASTER_SUCCESS({ stages: data.stages.items }));
            }

            if (data.serviceTypes?.items?.length >= 0) {
              actions.push(FETCH_SERVICETYPE_LIST_SUCCESS({ serviceTypeList: data.serviceTypes.items }));
            }

            if (data.classTypes?.items?.length >= 0) {
              actions.push(FETCH_CLASS_TYPE_LIST({ classTypes: data.classTypes.items }));
            }

            if (data.appointmentTypes?.items?.length >= 0) {
              actions.push(FETCH_APPOINTMENT_TYPE_LIST({ appointmentTypes: data.appointmentTypes.items }));
            }

            if (data.states?.length > 0) {
              actions.push(FETCH_STATE_MASTER_LIST_SUCCESS({ states: data.states }));
              if (state) {
                actions.push(FETCH_STATE_MASTER({ state }));
              }
            }

            if (data.cities?.length > 0) {
              actions.push(FETCH_CITY_MASTER_LIST_SUCCESS({ cities: data.cities }));
              if (city) {
                actions.push(FETCH_CITY_MASTER({ city }));
              }
            }

            if (data.staffList?.items?.length >= 0) {
              actions.push(FETCH_STAFF_LIST({ staffList: data.staffList.items }));
              actions.push(FETCH_STAFF_LIST_ALL({ staffListAll: data.staffList.items }));
            }

            if (data.tenantDetails) {
              actions.push(FETCHED_TENANT_BY_ID_SUCCESS({ tenant: data.tenantDetails }));
            }

            if (data.staffNotifications) {
              actions.push(FETCH_STAFF_NOTIFICATIONS({ 
                staffNotifications: data.staffNotifications, 
                companyId: tenant.company_id 
              }));
            }

            if (data.trials?.items?.length >= 0) {
              actions.push(FETCH_TRIAL_MASTER_LIST({ trials: data.trials.items }));
            }

            return SET_ACTIVE_TENANT_DATA({ actions });
          })
        );
      }),
      catchError((err) => {
        console.error('Critical error in setActiveTenant$:', err);
        return of(ERROR_TENANT_LIST({ err }));
      })
    );
  });

  // Handle multiple actions
  handleSetActiveTenantData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SET_ACTIVE_TENANT_DATA),
      tap(({ actions }) => {
        // Dispatch each action in the array
        actions.forEach(action => this.store.dispatch(action));
      })
    );
  }, { dispatch: false });

  // Helper methods
  private updateQueryParams(tenantId: string): void {
    const urlTree = this.router.createUrlTree([], {
      queryParams: { tenant: tenantId },
      queryParamsHandling: 'merge',
      preserveFragment: true
    }).toString();
    this.location.go(urlTree);
  }

  private findCountry(countries: Country[], countryCode: string): Country | undefined {
    return countries.find((country: Country) => 
      String(country.three_letter_code).toLowerCase() === String(countryCode).toLowerCase() ||
      String(country.two_letter_code).toLowerCase() === String(countryCode).toLowerCase()
    );
  }

  private findState(states: State[], stateCode: string): State | undefined {
    return states.find((state: State) => 
      String(state.code).toLowerCase() === String(stateCode).toLowerCase()
    );
  }

  private findCity(cities: City[], cityCode: string): City | undefined {
    return cities.find((city: City) => 
      String(city.code).toLowerCase() === String(cityCode).toLowerCase()
    );
  }

  statsigUpdateUser$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(STATSIG_UPDATE_USER),
      debounceTime(0),
      switchMap((action) => combineLatest([
        this.store.select(AUTH_STATE),
        this.store.select(COMPANY_INFO),  
        this.store.select(LOCATION_STATE),
        this.store.select(STAFF_STATE)
      ]).pipe(
        map(([authState, company, location, staff]: any) => {
          const tenant = action.selected_tenant;
          let user:any;
          if(authState && authState.user && staff && staff.staffList && staff.staffList.length > 0)
          {
            const staffDetails = staff.staffList.find((o: any) => { return o.id === parseInt(authState.user.Id) });
            user = {
              userID: authState.user.Id,
              email: authState.user.email,
              ip: location?.ip ? location.ip : "",
              userAgent: window.navigator.userAgent,
              appVersion: "1.0",// TODO : version management (through package .json or other way. )
              custom: {
                comp_id: tenant.company_id,
                tenant_id: tenant.id,
                tenant_country: tenant.country,
                comp_purchase_portal_enable: company.compDetails.purchase_portal_enable,
                comp_member_portal_enable: company.compDetails.member_portal_enable,
                tent_pri_lang: tenant.primary_language,
                tent_sec_lang: tenant.secondary_language,
                tent_city: tenant.city,
                tent_state: tenant.state,
                tent_country: tenant.country,
                tent_status: tenant.status
              }
            }
            Statsig.updateUser(user);
            this.featurebaseService.loadFeaturebaseSDK(() => {
              this.featurebaseService.initializeChangelogWidget();
              this.featurebaseService.initializeSurveyWidget(authState.user.email);
              this.featurebaseService.identifyUser(authState.user.email,staffDetails.name, authState.user.Id, staffDetails.ff_picture ? staffDetails.ff_picture : "" , (err?: any) => {
                if (err) {
                  console.error(err);
                } else {
                  this.featurebaseService.initializefeedbackWidget(authState.user.email);
                  console.log('User identified and data sent to Featurebase.');
                }
              });
            });
          }
          return STATSIG_UPDATE_USER_SUCCESS({ user })
        }),
      )),
    );
  });


  // HERE WE CAN Wait for different data states to get ready
  fetchRoomList$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('FETCH_ROOM_LIST'),
      withLatestFrom(this.store.select(TENANTS_INFO)),
      map((value: any) => {
        return value[1].selected_tenant;
      }),
      mergeMap((selectedTenant: any) => this.roomService.GetRoomList(selectedTenant.id)),
      map((rooms: ListRoomResponse) => {
        return (FETCH_ROOM_LIST({ rooms: rooms.items }))
      }),
      catchError((err) => of(console.log(err))),
    );
  });



  // HERE WE CAN Wait for different data states to get ready
  statsigInitialize$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('STATSIG_INITIALIZE'),
      tap(() => {

        Statsig.initialize(
          environment.STATSIG_SDK_KEY,
          null,
          // other objects i.e tenant and company id could be passed here ..
          { environment: { tier: environment.ENVIRONMENT_NAME } } // optional, pass options here if needed
        );
      }),
      catchError((err) => of(console.log(err))),
    );
  }, { dispatch: false });





  // push notifiction changes
  staffNotificationInitialize$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('STAFF_NOTIFiCATION_INITIALIZE'),
      tap(() => {

        const beamsClient = new PusherPushNotifications.Client({
          instanceId: environment.PUSHER_INSTANCE_ID
        });
        beamsClient
          .start()
          .then((beamsClient:any) => beamsClient.getDeviceId())
          .then((deviceId) =>
            console.log("Successfully registered with Beams. Device ID:", deviceId)
          )
          .catch(console.error);
      }),
      catchError((err) => of(console.log("noti2",err))),
    );
  }, { dispatch: false });

  // staff notification topic subscribe
  staffNotificationTopicInitialize$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(FETCH_STAFF_NOTIFICATIONS),
      debounceTime(0),
        map((action: any) => {
          if(!action.staffNotifications) {
            return STAFF_NOTIFICARIONS_SUCCESS({ staffNotifications: action.staffNotifications });
          }  
          else if(action.staffNotifications.subscribed_topics && action.staffNotifications.subscribed_topics.length > 0 
            && action.staffNotifications.subscribed_topics.filter((topic: StaffNotificationTopics) => topic.isSubscribed).length == 0)
          {
            return  STAFF_NOTIFICARIONS_SUCCESS({ staffNotifications:action.staffNotifications });
          }
          else{
            const data = action.staffNotifications as StaffNotification;
            const beamsClient = new PusherPushNotifications.Client({
              instanceId: environment.PUSHER_INSTANCE_ID
            });
            beamsClient.start().then(() => console.log("Registered with beams!"));
            beamsClient
              .start()
              .then((beamsClient:any) => beamsClient.getDeviceId())
              .then((deviceId) =>
                console.log("Successfully registered with Beams. Device ID:", deviceId)
              )
              .then(() => {
                if(data.subscribed_topics) {  
                  const excludeTopics: any[] = ['IncomingSMS','IncomingEmail','IncomingWhatsApp'];
                  const allTopics = data.subscribed_topics.filter((topic: StaffNotificationTopics) => !excludeTopics.includes(topic.notificationSubscriptionTopic) );
                  data.tenant_ids.forEach(t => {
                    allTopics.forEach((topic : StaffNotificationTopics)=> {
                      if(topic.isSubscribed)
                         beamsClient.addDeviceInterest(`${action.companyId}_${t}_${topic.notificationSubscriptionTopic}`)
                    });
                  });
                }
                }
               )
              .then(() => beamsClient.getDeviceInterests())
              // .then((interests) => console.log("Current interests:", interests))
              .catch(console.error);
          }
          return  STAFF_NOTIFICARIONS_SUCCESS({ staffNotifications:action.staffNotifications })
        }),
        catchError((err) => of(console.log(err)))
    );
  });


  getCurrentLocation$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType('FETCH_CURRENT_LOCATION'),
      mergeMap(() => {
        return this.locationService.getPosition()
      }),
      map((res: any) => {
        return (FETCHED_CURRENT_LOCATION({ location: res }))
      }),
      catchError((err) => of(console.log(err))),
    );
  });


  login$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(LOGIN),
      switchMap((data) => {
        return this.authService.login(data.loginInput).pipe(
          map((response: LoginResponse) => {
            if (response.token)
            {
              localStorage.setItem('token', response.token);
              localStorage.setItem('refresh_token', response.refresh_token);
              localStorage.setItem('auth_response', JSON.stringify(response));
            }
            const user = this.authService.decodedJwtToken(response.token)
            return LOGIN_SUCCESS({ user, token: response.token, redirect: true, auth_response: response });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(LOGIN_FAILED({ error: JSON.stringify(error) }));
          })
        );
      })
    );
  });


  loginWithGoogle$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(LOGIN_WITH_GOOGLE),
      switchMap((data) => {
        return this.authService.socialLogin(data.loginInput).pipe(
          map((response: LoginResponse) => {
            if (response.token)
            {
              localStorage.setItem('token', response.token);
              localStorage.setItem('refresh_token', response.refresh_token);
            }
            localStorage.setItem('auth_response', JSON.stringify(response));
            const user = this.authService.decodedJwtToken(response.token)
            return LOGIN_SUCCESS({ user, token: response.token, redirect: true, auth_response: response });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(LOGIN_FAILED({ error: JSON.stringify(error) }));
          })
        );
      })
    );
  }, { dispatch: false });

  autoLogin$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AUTO_LOGIN),
      mergeMap(() => {
        const user = this.authService.decodedToken;
        const refresh_token = this.authService.refreshTokenFromStorage;
        if (user && refresh_token)
          return of(LOGIN_SUCCESS(LOGIN_SUCCESS({ user, token: localStorage.getItem('token') || '', redirect: false, auth_response: JSON.parse(localStorage.getItem('auth_response') || '{}') })))
        else return of();
      })
    );
  });


  loginSuccess$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(LOGIN_SUCCESS),
      tap((action) => {
        this.store.dispatch(SET_CLAIMS_DETAILS({ claims: this.authService.parseDecodedToken }));
        this.store.dispatch({ type: 'FETCHED_TENANT_LIST' });
        this.store.dispatch({ type: 'FETCHED_COMPANY_DETAILS' });
        this.store.dispatch({ type: 'STATSIG_INITIALIZE' });
        this.store.dispatch({ type: 'STAFF_NOTIFiCATION_INITIALIZE' });
        if (action.redirect) {
          const returnUrl = this.activeRoute.snapshot.queryParamMap.get('returnUrl');
          if (returnUrl) {
            this.router.navigateByUrl(returnUrl);
          }
          else {
            this.router.navigateByUrl(CONSTANTS_DATA.DEFAULT.LOGIN_SUCCESS_REDIRECTION);
          }
        }

      }
      ))
  }, { dispatch: false });

  // setTheme$ = createEffect((): Observable<any> => {
  //   return this.actions$.pipe(
  //     ofType(SET_USER_THEME),
  //     tap((action: any) => {
  //       const user = this.authService.decodedToken;
  //       if(user)
  //       {
  //         this.staff.GetStaffById(user.Id).subscribe((staff: any) => {  
  //           var staffTheme = staff.theme;
  //           if(staffTheme)
  //           {
  //             var themes = THEME_CONFIG.find((theme: ThemeOption) => theme.class == staffTheme.theme_mode)!;
  //             if(themes)
  //             {
  //               var selectedTheme = themes.colors.find((color: ThemeColor) => color.themeName.toLowerCase() === staffTheme.colour.toLowerCase());
  //               if(selectedTheme)
  //                 this.store.dispatch(setTheme({ theme: selectedTheme }));
  //             }
  //           }
  //         })
  //       }
  //     })  
  //   );
  // }, { dispatch: false });


  logout$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(ActionTypes.LOGOUT),
      map(() => {
        this.authService.revokeToken().subscribe({
          next: () => {
            localStorage.clear();
            Statsig.updateUser(null);
            this.router.navigate(['/auth/login']);
            return STATSIG_UPDATE_USER_SUCCESS({ user: null })
          },
          error: () => {
            console.log('Token revoke failed');
            localStorage.clear();
            Statsig.updateUser(null);
            this.router.navigate(['/auth/login']);
            return STATSIG_UPDATE_USER_SUCCESS({ user: null })
          }
        });
      }
      ))
  }, { dispatch: false });


  get getAllParams(): Array<any> {
    return [...this.staffListParams.values()];
  }

}

